'use strict'

import Vue from 'vue'
import axios from 'axios'
import { RESPONSE } from '@/constants/response'
import { auth } from '@/store/auth.module'
import router from '@/router'
import store from '@/store'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  baseURL: process.env.VUE_APP_API_BASE_URL
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    let user = store.state.auth.user
    if (user && user.access_token) {
      config.headers.common['Authorization'] = 'Bearer ' + user.access_token
    } else {
      config.headers.common['Authorization'] = null
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  // function (error) {
  //   // Do something with response error
  //   return Promise.reject(error)
  // }
  async (error) => {
    const errorAPI = error.config
    if (
      error.response.status === RESPONSE.CODE.TOKEN_EXPIRED &&
      errorAPI.retry === undefined
    ) {
      errorAPI.retry = true

      try {
        const { user } = await store.dispatch('auth/refreshToken')
        auth.state.status = { loggedIn: true }
        auth.state.user = user
        localStorage.setItem('user', JSON.stringify(user))

        return axios(errorAPI)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        router.replace('/webapp')
      }
    }
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default _axios
